import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { createContext } from 'react';
// utils
// ----------------------------------------------------------------------

// NOTE:
// We only build demo at basic level.
// Customer will need to do some extra handling yourself if you want to extend the logic and other features...

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export const FilterContext = createContext({
  openFilter: false,
  setOpenFilter: () => Promise.resolve(),
  filters: [],
  setFilters: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

FilterProvider.propTypes = {
  children: PropTypes.node,
};

export function FilterProvider({ children }) {
  const [filters, setFilters] = React.useState([]);
  const [openFilter, setOpenFilter] = React.useState(false);

  const router = useRouter();

  React.useEffect(() => {
    router.events.on('routeChangeComplete', () => {
      // reset filter on the route changes
      setFilters([]);
    });

    return () => {
      router.events.off('routeChangeComplete');
    };
  }, [router]);

  return (
    <FilterContext.Provider
      value={{
        filters,
        setFilters,
        openFilter,
        setOpenFilter,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
}
